export default __webpack_public_path__ + "static/media/background.e961f195.jpg";